package frontend.lib

import frontend.lib.LocalString.*

fun translatorEN(message: LocalString): String =
    when(message) {
        LoginInvalid -> "Login name is invalid"
        LoginUnavailable -> "Login name is unavailable"
        InvalidInviteCode -> "Invite code is invalid"
        LoginEmpty -> "Login name must be provided"
        PasswordEmpty -> "Password must be provided"
        PasswordNotMatch -> "Passwords not match"
        BadCredentials -> "Login or password is incorrect"
    }

enum class LocalString {
    LoginInvalid,
    LoginUnavailable,
    InvalidInviteCode,
    LoginEmpty,
    PasswordEmpty,
    PasswordNotMatch,
    BadCredentials;

    val t by lazy {
        translatorEN(this)
    }
}